import React, { FC } from 'react';
import styled from 'styled-components';
import { Colors } from '../../../styles/colors';
import { Link } from 'react-router-dom';

export interface LinkLabelProps {
  for: string;
  label: string;
  link?: {
    text?: string;
    route?: string;
    actionFn?: () => void;
  }
  ignoreTabIndex?: boolean;
}

const LabelWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const StyledLabel = styled.label`
  width: auto;
  color: ${Colors.grayDark};
  margin-bottom: 1rem;
  font-size: 1rem;
  display: flex;
  flex-direction: row;
`;

const LabelLink = styled(Link)`
   width: auto;
   font-size: 1rem;
   color: ${Colors.grayDark};
   text-decoration: underline;
   align-self: center;
   margin-bottom: 1rem;
`;

const ButtonLink = styled.button`
   width: auto;
   font-size: 1rem;
   color: ${Colors.grayDark};
   text-decoration: underline;
   align-self: center;
   margin-bottom: 1rem;
`;
export const LinkLabel: FC<LinkLabelProps> = (props, ignoreTabIndex = false) => {
  return (
    <LabelWrapper>
      <StyledLabel htmlFor={props.for}>{props.label}</StyledLabel>
      {
        props.link?.actionFn ? (
          <ButtonLink
            type={'button'}
            tabIndex={ignoreTabIndex ? -1 : 0}
            onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
              event.preventDefault();
              props.link.actionFn();
            }}
          >
            { props.link.text }
          </ButtonLink>
        ) : (
          <>
          {
            props.link &&
            <LabelLink tabIndex={ignoreTabIndex ? -1 : 0} to={props.link.route}>
              { props.link.text }
            </LabelLink>
          }
          </>
        )
      }
    </LabelWrapper>
  );
};
